export default "__VITE_ASSET__CRKvKD8G__"